export const UPLOAD_DOCUMENT_STEPS = {
  UPLOAD_DOCUMENT: 1,
  SET_DOCUMENT_NAME: 2,
  SELECT_DESTINATION: 3,
  SET_DOCUMENT_DETAILS: 4,
};
